<template>
  <search-from
    :fields="fields"
    :pagination="pagination"
    :show-advanced="showAdvanced"
    @click="onSearch"
  ></search-from>
</template>

<script>
    import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
    import SearchFrom from "../../base/SearchForm";
    import {PaginationMeta} from "../../../models/PaginationMeta";

    const ListingRepo = RepositoryFactory.get('newsletterListing')

    export default {
        name: 'listing-search-form',
        components: {
          SearchFrom,
        },
        props: {
          pagination: {
            type: Object,
            default: new PaginationMeta(),
          },
          fields: {
            type: Array,
            default: new Array(),
          },
          showAdvanced: {
            type: Boolean,
            default: true,
          },
        },
        methods: {
          onSearch(params) {
                this.$emit('click', params)
                ListingRepo
                    .searchListing(params)
                    .then(
                        response => (
                            this.$emit('change', response.data)
                        )
                    )
            },
        }
    }
</script>
